import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { Operator_Summary_Table_Header } from "../../../utils/helperData";

const OperatoSummaryTable = ({ data, tableHeader }) => {
  //  if (
  //    !data ||
  //    typeof data !== "object" ||
  //    !Array.isArray(data.data) ||
  //    data.data.length === 0
  //  ) {
  //    return (
  //      <div className="flex justify-center pt-5">
  //        <p>No data available</p>
  //      </div>
  //    );
  //  }

  console.log("opperator xdara", data);
  const isDataEmpty =
    !data ||
    typeof data !== "object" ||
    !Array.isArray(data?.data) ||
    data?.data?.length === 0;

  return (
    <div className="flex justify-center overflow-auto pt-5">
      <TableContainer
        component={Paper}
        sx={{
          width: "100%",
          maxWidth: "100%",
          height: "100%",
          maxHeight: "350px",
          overflow: "auto",
          border: "1px solid #E2E8F0",
          borderRadius: "12px",
          boxShadow: "none",
        }}
      >
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              {tableHeader?.map((header, index) => (
                <TableCell
                  key={index}
                  sx={{
                    fontWeight: 600,
                    fontSize: "14px",
                    color: "#334155",
                    backgroundColor: "#F8FAFC",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {header}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {isDataEmpty ? (
              <TableRow>
                <TableCell
                  colSpan={Operator_Summary_Table_Header.length}
                  align="center"
                  sx={{ fontSize: "14px", color: "#64748B" }}
                >
                  No data found
                </TableCell>
              </TableRow>
            ) : (
              data?.data?.map((item, index) => {
                return (
                  <TableRow
                    key={index}
                    hover
                    sx={{
                      "&:hover": {
                        backgroundColor: "#F8FAFC",
                      },
                    }}
                  >
                    <TableCell
                      sx={{
                        fontSize: "14px",
                        color: "#475569",
                        fontWeight: 500,
                      }}
                    >
                      {item.operator}
                    </TableCell>
                    <TableCell
                      sx={{
                        fontSize: "14px",
                        color: "#475569",
                        fontWeight: 500,
                      }}
                    >
                      {item.name || "-"}
                    </TableCell>
                    <TableCell
                      sx={{
                        fontSize: "14px",
                        color: "#475569",
                        fontWeight: 500,
                      }}
                    >
                      {item.total_accepted}
                    </TableCell>
                    <TableCell
                      sx={{
                        fontSize: "14px",
                        color: "#475569",
                        fontWeight: 500,
                      }}
                    >
                      {item.total_rejects}
                    </TableCell>
                    <TableCell
                      sx={{
                        fontSize: "14px",
                        color: "#475569",
                        fontWeight: 500,
                      }}
                    >
                      {item.total_welds}
                    </TableCell>
                    <TableCell
                      sx={{
                        fontSize: "14px",
                        color: "#475569",
                        fontWeight: 500,
                      }}
                    >
                      {item.id_insp_total}
                    </TableCell>
                    <TableCell
                      sx={{
                        fontSize: "14px",
                        color: "#475569",
                        fontWeight: 500,
                      }}
                    >
                      {item.id_insp_rate?.toFixed(2)}%
                    </TableCell>
                    <TableCell
                      sx={{
                        fontSize: "14px",
                        color: "#475569",
                        fontWeight: 500,
                      }}
                    >
                      {item?.current_accepted_streak?.count}
                    </TableCell>
                    <TableCell
                      sx={{
                        fontSize: "14px",
                        color: "#475569",
                        fontWeight: 500,
                      }}
                    >
                      {item?.other_ins_type_count}
                    </TableCell>
                    <TableCell
                      sx={{
                        fontSize: "14px",
                        color: "#475569",
                        fontWeight: 500,
                      }}
                    >
                      {item.reject_rate?.toFixed(2)}%
                    </TableCell>
                  </TableRow>
                );
              })
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};
export default OperatoSummaryTable;
